import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import { lifecycle } from 'recompose'
import RoleSelection from './RoleSelection'
import RoleWidget from './RoleWidget'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import ContentBox from '../../../layout/component/ContentBox'

const ManageRoleWidgets = (props) => {
    return (
        <div>
            <ContentBox title="Manage role widgets">
                <RoleSelection {...props}/>
                <Row top="M">
                    <Column size={6}>
                        <RoleWidget {...props}/>
                    </Column>
                </Row>
            </ContentBox>
        </div>
    )
}

ManageRoleWidgets.propTypes = {
    roleList: PropTypes.array.isRequired,
    findAllRole: PropTypes.func.isRequired,
    changeCurrentRoleId: PropTypes.func.isRequired,
    toggleRoleWidgetAccess: PropTypes.func.isRequired,
    changeRole: PropTypes.func.isRequired,
    saveRole: PropTypes.func.isRequired,
    currentRole: PropTypes.object,
}

export default lifecycle({
    componentDidMount () {
        this.props.findAllRole()
    },
})(withLayout(ManageRoleWidgets))




// WEBPACK FOOTER //
// ./src/modules/security/component/manage/ManageRoleWidgets.js